module.exports = __webpack_public_path__ + "static/media/news-martin-peabody-award.ad268d85.jpg";